// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RichTextEditor_editorWrap__nV5ie {
  border: 1px solid #E5E7EB;
  border-radius: 12px;
  overflow: hidden;
  background: #ffffff;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}
.RichTextEditor_editorWrap__nV5ie:focus-within {
  border-color: #4c2fb3;
  box-shadow: 0 0 0 3px rgba(124, 92, 252, 0.15);
}

.RichTextEditor_toolbar__FcFbY {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
  padding: 8px 10px;
  background: #FAFAFC;
  border-bottom: 1px solid #EEF0F6;
}

.RichTextEditor_toolBtn__W9Tnc {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: #4B5563;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
}
.RichTextEditor_toolBtn__W9Tnc:hover {
  background: #F5F3FE;
  color: #4c2fb3;
}

.RichTextEditor_toolDivider__EYHOi {
  width: 1px;
  height: 20px;
  background: #E5E7EB;
  margin: 0 4px;
}

.RichTextEditor_toolSpacer__Mg3ZR {
  flex: 1 1;
}

.RichTextEditor_tokenMenuWrap__4JR8\\+ {
  position: relative;
}

.RichTextEditor_tokenTrigger__TdIsA {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #F5F3FE;
  color: #4c2fb3;
  border: none;
  border-radius: 8px;
  font-size: 12.5px;
  font-weight: 700;
  padding: 7px 12px;
  cursor: pointer;
  transition: background 0.15s ease;
  white-space: nowrap;
}
.RichTextEditor_tokenTrigger__TdIsA:hover {
  background: #E7DEFB;
}

.RichTextEditor_tokenMenu__65bUo {
  position: absolute;
  top: calc(100% + 6px);
  right: 0;
  left: auto;
  z-index: 30;
  display: flex;
  flex-direction: column;
  gap: 2px;
  background: #ffffff;
  border: 1px solid #E7E9F1;
  border-radius: 12px;
  box-shadow: 0 20px 44px rgba(27, 37, 89, 0.16);
  padding: 8px;
  min-width: 240px;
  max-height: 280px;
  overflow-y: auto;
}

.RichTextEditor_tokenMenuItem__YhADb {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 8px 10px;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.15s ease;
}
.RichTextEditor_tokenMenuItem__YhADb:hover {
  background: #F5F3FE;
}

.RichTextEditor_tokenMenuLabel__XdaBq {
  font-size: 12.5px;
  font-weight: 600;
  color: #1F2430;
  white-space: nowrap;
}

.RichTextEditor_tokenMenuCode__CKi8C {
  font-family: 'Courier New', monospace;
  font-size: 11px;
  color: #4c2fb3;
  background: #F5F3FE;
  padding: 2px 6px;
  border-radius: 6px;
  white-space: nowrap;
}

.RichTextEditor_editorBody__-R7-I {
  padding: 16px 18px;
  font-size: 13.5px;
  line-height: 1.7;
  color: #1F2430;
  outline: none;
  overflow-y: auto;
}
.RichTextEditor_editorBody__-R7-I:empty::before {
  content: attr(data-placeholder);
  color: #9CA3AF;
}
.RichTextEditor_editorBody__-R7-I ul,
.RichTextEditor_editorBody__-R7-I ol {
  padding-left: 22px;
  margin: 6px 0;
}
.RichTextEditor_editorBody__-R7-I p {
  margin: 0 0 8px;
}
`, "",{"version":3,"sources":["webpack://./src/components/RichTextEditor/RichTextEditor.module.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,0DAA0D;AAC5D;AACA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,mDAAmD;AACrD;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,iCAAiC;EACjC,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,8CAA8C;EAC9C,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,iCAAiC;AACnC;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,+BAA+B;EAC/B,cAAc;AAChB;AACA;;EAEE,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,eAAe;AACjB","sourcesContent":[".editorWrap {\n  border: 1px solid #E5E7EB;\n  border-radius: 12px;\n  overflow: hidden;\n  background: #ffffff;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n.editorWrap:focus-within {\n  border-color: #4c2fb3;\n  box-shadow: 0 0 0 3px rgba(124, 92, 252, 0.15);\n}\n\n.toolbar {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 4px;\n  padding: 8px 10px;\n  background: #FAFAFC;\n  border-bottom: 1px solid #EEF0F6;\n}\n\n.toolBtn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 30px;\n  height: 30px;\n  border: none;\n  border-radius: 8px;\n  background: transparent;\n  color: #4B5563;\n  cursor: pointer;\n  transition: background 0.15s ease, color 0.15s ease;\n}\n.toolBtn:hover {\n  background: #F5F3FE;\n  color: #4c2fb3;\n}\n\n.toolDivider {\n  width: 1px;\n  height: 20px;\n  background: #E5E7EB;\n  margin: 0 4px;\n}\n\n.toolSpacer {\n  flex: 1;\n}\n\n.tokenMenuWrap {\n  position: relative;\n}\n\n.tokenTrigger {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background: #F5F3FE;\n  color: #4c2fb3;\n  border: none;\n  border-radius: 8px;\n  font-size: 12.5px;\n  font-weight: 700;\n  padding: 7px 12px;\n  cursor: pointer;\n  transition: background 0.15s ease;\n  white-space: nowrap;\n}\n.tokenTrigger:hover {\n  background: #E7DEFB;\n}\n\n.tokenMenu {\n  position: absolute;\n  top: calc(100% + 6px);\n  right: 0;\n  left: auto;\n  z-index: 30;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  background: #ffffff;\n  border: 1px solid #E7E9F1;\n  border-radius: 12px;\n  box-shadow: 0 20px 44px rgba(27, 37, 89, 0.16);\n  padding: 8px;\n  min-width: 240px;\n  max-height: 280px;\n  overflow-y: auto;\n}\n\n.tokenMenuItem {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  padding: 8px 10px;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: background 0.15s ease;\n}\n.tokenMenuItem:hover {\n  background: #F5F3FE;\n}\n\n.tokenMenuLabel {\n  font-size: 12.5px;\n  font-weight: 600;\n  color: #1F2430;\n  white-space: nowrap;\n}\n\n.tokenMenuCode {\n  font-family: 'Courier New', monospace;\n  font-size: 11px;\n  color: #4c2fb3;\n  background: #F5F3FE;\n  padding: 2px 6px;\n  border-radius: 6px;\n  white-space: nowrap;\n}\n\n.editorBody {\n  padding: 16px 18px;\n  font-size: 13.5px;\n  line-height: 1.7;\n  color: #1F2430;\n  outline: none;\n  overflow-y: auto;\n}\n.editorBody:empty::before {\n  content: attr(data-placeholder);\n  color: #9CA3AF;\n}\n.editorBody ul,\n.editorBody ol {\n  padding-left: 22px;\n  margin: 6px 0;\n}\n.editorBody p {\n  margin: 0 0 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"editorWrap": `RichTextEditor_editorWrap__nV5ie`,
	"toolbar": `RichTextEditor_toolbar__FcFbY`,
	"toolBtn": `RichTextEditor_toolBtn__W9Tnc`,
	"toolDivider": `RichTextEditor_toolDivider__EYHOi`,
	"toolSpacer": `RichTextEditor_toolSpacer__Mg3ZR`,
	"tokenMenuWrap": `RichTextEditor_tokenMenuWrap__4JR8+`,
	"tokenTrigger": `RichTextEditor_tokenTrigger__TdIsA`,
	"tokenMenu": `RichTextEditor_tokenMenu__65bUo`,
	"tokenMenuItem": `RichTextEditor_tokenMenuItem__YhADb`,
	"tokenMenuLabel": `RichTextEditor_tokenMenuLabel__XdaBq`,
	"tokenMenuCode": `RichTextEditor_tokenMenuCode__CKi8C`,
	"editorBody": `RichTextEditor_editorBody__-R7-I`
};
export default ___CSS_LOADER_EXPORT___;
